/**
 * Runtime configuration read from Vite env vars.
 * Getters (not constants) so tests can stub env at call time.
 * All VITE_* values are inlined into the public bundle — never put secrets here.
 */
const DEFAULT_GUIDE_PDF_URL = 'https://cotrackpro-partner.s3.us-east-1.amazonaws.com/EmpowerED_Accountability.pdf';
const DEFAULT_ONE_SHEET_URL = 'https://cotrackpro-partner.s3.us-east-1.amazonaws.com/EmpowerED_Speaker_OneSheet.pdf';

export const config = {
  /** POST endpoint for lead submissions. Empty → mailto fallback. */
  get leadEndpoint(): string { return import.meta.env.VITE_LEAD_ENDPOINT ?? ''; },
  /** Recipient for the mailto fallback. */
  get tracyEmail(): string { return import.meta.env.VITE_TRACY_EMAIL || 'curtisempowered@gmail.com'; },
  /** Plausible data-domain. Empty → analytics disabled. */
  get analyticsId(): string { return import.meta.env.VITE_ANALYTICS_ID ?? ''; },
  get oneSheetUrl(): string { return import.meta.env.VITE_ONE_SHEET_URL || DEFAULT_ONE_SHEET_URL; },
  get guidePdfUrl(): string { return import.meta.env.VITE_GUIDE_PDF_URL || DEFAULT_GUIDE_PDF_URL; },
};
